import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, Mail } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/social-planner`;

export const MonthReport = ({ month }) => {
  const [r, setR] = useState(null);
  const [busy, setBusy] = useState("");
  const m = month || new Date().toISOString().slice(0, 7);
  const load = async () => { setBusy("load"); try { setR((await axios.get(`${API}/report`, { params: { month: m } })).data); } catch (e) { toast.error(e.message); } setBusy(""); };
  const send = async () => { setBusy("send"); try { await axios.post(`${API}/report/send`, null, { params: { month: m } }); toast.success("Raportul a fost trimis pe email"); } catch (e) { toast.error(e.response?.data?.detail || e.message); } setBusy(""); };

  return (
    <div className="rounded-xl border border-zinc-800 bg-zinc-900/50 p-4" data-testid="month-report">
      <div className="flex flex-wrap items-center gap-2">
        <p className="text-sm font-medium text-zinc-100">Raport {m}</p>
        <span className="text-xs text-zinc-500">se trimite automat pe email pe 1 ale lunii, pentru luna trecută</span>
        <button data-testid="report-preview-btn" onClick={load} disabled={!!busy} className="ml-auto rounded-full border border-zinc-700 px-3 py-1 text-xs text-zinc-200 hover:border-amber-400">{busy === "load" ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : "Vezi rezumatul"}</button>
        <button data-testid="report-send-btn" onClick={send} disabled={!!busy} className="flex items-center gap-1 rounded-full bg-zinc-100 px-3 py-1 text-xs font-medium text-zinc-950 hover:bg-amber-400">{busy === "send" ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Mail className="h-3.5 w-3.5" />} Trimite pe email acum</button>
      </div>
      {r && (
        <div className="mt-3 grid gap-3 text-xs text-zinc-300 md:grid-cols-3" data-testid="report-summary">
          <p><b className="text-zinc-100">{r.posts}</b> postări · {r.stories} Story-uri<br />❤ {r.totals.likes} · 💬 {r.totals.comments} · ↗ {r.totals.shares}<br />Creative AI: ${r.creative_spend_usd.toFixed(2)}</p>
          <div><p className="font-medium text-zinc-100">Top postări</p>{r.top_posts.length ? r.top_posts.map((p, i) => <p key={i}>{i + 1}. {p.title?.slice(0, 40)} — scor {p.score}</p>) : <p className="text-zinc-500">fără date</p>}</div>
          <div><p className="font-medium text-zinc-100">Top produse</p>{r.top_products.length ? r.top_products.map(([n, s], i) => <p key={i}>{i + 1}. {n?.slice(0, 40)} — {s}</p>) : <p className="text-zinc-500">fără date</p>}</div>
        </div>
      )}
    </div>
  );
};
